export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  category: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  posterImage: string;
  coverImage: string;
  tags: string[];
  resolution: string;
  region: string;
}

export const categories = [
  { slug: 'sci-fi', name: '科幻电影', icon: 'ri-rocket-2-line' },
  { slug: 'action', name: '动作电影', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧电影', icon: 'ri-emotion-happy-line' },
  { slug: 'romance', name: '爱情电影', icon: 'ri-heart-line' },
  { slug: 'horror', name: '恐怖电影', icon: 'ri-ghost-line' },
  { slug: 'animation', name: '动画电影', icon: 'ri-movie-2-line' },
  { slug: 'suspense', name: '悬疑电影', icon: 'ri-search-eye-line' },
  { slug: 'war', name: '战争电影', icon: 'ri-sword-line' },
];

export const movies: Movie[] = [
  {
    id: 'interstellar',
    title: '星际穿越',
    originalTitle: 'Interstellar',
    category: 'sci-fi',
    year: 2014,
    rating: 9.4,
    duration: '169分钟',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦', '迈克尔·凯恩'],
    description: '近未来的地球黄沙遍野，小麦、秋葵等基础农作物相继因枯萎病灭绝，人类不再像从前那样仰望星空，放纵想象力和灵感的迸发，而是每日在沙尘暴的肆虐下倒数着所剩不多的光景。在家务农的前NASA宇航员库珀接连在女儿墨菲的书房发现奇怪的重力场现象，随即得知在某个未知区域内前NASA成员仍秘密进行一个拯救人类的计划。',
    posterImage: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%2C%20astronaut%20floating%20in%20space%20near%20black%20hole%2C%20cinematic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20epic%20science%20fiction%20film%20style%2C%20dramatic%20composition%2C%20minimalist%20design%20with%20stars%20background&width=600&height=900&seq=movie-interstellar-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20scene%2C%20black%20hole%20Gargantua%2C%20spaceship%20Endurance%2C%20epic%20space%20landscape%2C%20cinematic%20lighting%2C%20dark%20cosmic%20background%20with%20golden%20light%2C%20science%20fiction%20film%20aesthetic&width=1600&height=700&seq=movie-interstellar-cover&orientation=landscape',
    tags: ['科幻', '冒险', '亲情', '太空'],
    resolution: '蓝光1080P',
    region: '美国',
  },
  {
    id: 'matrix',
    title: '黑客帝国',
    originalTitle: 'The Matrix',
    category: 'sci-fi',
    year: 1999,
    rating: 9.1,
    duration: '136分钟',
    director: '沃卓斯基姐妹',
    cast: ['基努·里维斯', '劳伦斯·菲什伯恩', '凯瑞-安·莫斯', '雨果·维文'],
    description: '网络黑客尼奥对这个看似正常的现实世界产生了怀疑。他结识了黑客崔妮蒂，并见到了黑客组织的首领墨菲斯。墨菲斯告诉他，现实世界其实是由一个名叫"矩阵"的计算机人工智能系统控制的虚拟世界。尼奥成为了拯救人类的救世主，与矩阵展开了激烈的对抗。',
    posterImage: 'https://readdy.ai/api/search-image?query=The%20Matrix%20movie%20poster%2C%20green%20digital%20rain%20code%2C%20Neo%20in%20black%20trench%20coat%2C%20dark%20cyberpunk%20aesthetic%2C%20minimalist%20film%20poster%20design%2C%20green%20and%20black%20color%20scheme&width=600&height=900&seq=movie-matrix-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=The%20Matrix%20movie%20scene%2C%20green%20digital%20rain%20falling%2C%20cyberpunk%20city%2C%20dark%20atmosphere%2C%20Neo%20dodging%20bullets%2C%20cinematic%20slow%20motion%2C%20green%20tinted%20dark%20background&width=1600&height=700&seq=movie-matrix-cover&orientation=landscape',
    tags: ['科幻', '动作', '哲学', '赛博朋克'],
    resolution: '蓝光1080P',
    region: '美国',
  },
  {
    id: 'inception',
    title: '盗梦空间',
    originalTitle: 'Inception',
    category: 'sci-fi',
    year: 2010,
    rating: 9.3,
    duration: '148分钟',
    director: '克里斯托弗·诺兰',
    cast: ['莱昂纳多·迪卡普里奥', '约瑟夫·高登-莱维特', '艾伦·佩吉', '汤姆·哈迪'],
    description: '道姆·柯布是一位经验老道的窃贼，他能够潜入人们精神最为脆弱的梦境中，窃取潜意识中有价值的秘密。柯布这一罕见的技能使他成为危险的企业间谍活动中最令人垂涎的对象，但这也让他成为了一名国际逃犯，失去自己的所爱。如今柯布有了一个赎罪的机会，只要完成最后一项任务他的生活就会恢复原状。',
    posterImage: 'https://readdy.ai/api/search-image?query=Inception%20movie%20poster%2C%20city%20folding%20inward%2C%20surreal%20dream%20landscape%2C%20Leonardo%20DiCaprio%2C%20dark%20and%20moody%20cinematic%20style%2C%20minimalist%20design%2C%20layered%20reality%20concept&width=600&height=900&seq=movie-inception-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Inception%20movie%20scene%2C%20folding%20cityscape%2C%20dream%20within%20dream%2C%20surreal%20architecture%2C%20dark%20atmospheric%20cinematic%20lighting%2C%20warm%20golden%20tones%20mixed%20with%20deep%20shadows&width=1600&height=700&seq=movie-inception-cover&orientation=landscape',
    tags: ['科幻', '悬疑', '动作', '梦境'],
    resolution: '蓝光4K',
    region: '美国',
  },
  {
    id: 'john-wick',
    title: '疾速追杀',
    originalTitle: 'John Wick',
    category: 'action',
    year: 2014,
    rating: 8.8,
    duration: '101分钟',
    director: '查德·斯塔赫斯基',
    cast: ['基努·里维斯', '迈克尔·恩奎斯特', '阿尔菲·艾伦', '威廉·达福'],
    description: '约翰·威克是一名退休的杀手，他的妻子刚刚去世，留下一条狗陪伴他。然而一群混混闯进他的家，偷走了他的车，还杀害了他的狗。这激怒了约翰·威克，他重新拿起武器，踏上了一条血腥的复仇之路。曾经被称为"夜魔"的男人，再次展现了他令人胆寒的杀人技巧。',
    posterImage: 'https://readdy.ai/api/search-image?query=John%20Wick%20movie%20poster%2C%20Keanu%20Reeves%20in%20black%20suit%20holding%20gun%2C%20dark%20cinematic%20lighting%2C%20action%20film%20aesthetic%2C%20minimalist%20poster%20design%2C%20red%20and%20black%20color%20scheme&width=600&height=900&seq=movie-johnwick-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=John%20Wick%20action%20movie%20scene%2C%20gunfight%20in%20neon%20lit%20nightclub%2C%20Keanu%20Reeves%20in%20black%20suit%2C%20stylish%20action%20cinematography%2C%20dark%20background%20with%20neon%20accents%2C%20intense%20mood&width=1600&height=700&seq=movie-johnwick-cover&orientation=landscape',
    tags: ['动作', '犯罪', '复仇', '枪战'],
    resolution: '蓝光1080P',
    region: '美国',
  },
  {
    id: 'mad-max',
    title: '疯狂的麦克斯：狂暴之路',
    originalTitle: 'Mad Max: Fury Road',
    category: 'action',
    year: 2015,
    rating: 8.8,
    duration: '120分钟',
    director: '乔治·米勒',
    cast: ['汤姆·哈迪', '查理兹·塞隆', '尼古拉斯·霍尔特', '休·基斯-拜恩'],
    description: '在未来世界，水资源短缺引发了连绵的战争。人们相互厮杀，争夺有限的资源。前公路巡警麦克斯成为了费罗莎指挥官战车的司机，带着五个女人横穿沙漠，逃离暴虐的统治者不死老乔的魔掌。一场史诗般的公路追逐战在荒漠中展开。',
    posterImage: 'https://readdy.ai/api/search-image?query=Mad%20Max%20Fury%20Road%20movie%20poster%2C%20post%20apocalyptic%20desert%2C%20war%20rig%20vehicle%2C%20orange%20and%20teal%20color%20grade%2C%20action%20film%20style%2C%20explosive%20cinematic%20design%2C%20dust%20storm%20background&width=600&height=900&seq=movie-madmax-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Mad%20Max%20Fury%20Road%20movie%20scene%2C%20epic%20desert%20chase%2C%20orange%20dust%20storm%2C%20war%20vehicles%2C%20post%20apocalyptic%20wasteland%2C%20cinematic%20action%2C%20dramatic%20lighting%20with%20warm%20orange%20tones&width=1600&height=700&seq=movie-madmax-cover&orientation=landscape',
    tags: ['动作', '科幻', '冒险', '末日'],
    resolution: '蓝光4K',
    region: '美国',
  },
  {
    id: 'little-red-flower',
    title: '送你一朵小红花',
    originalTitle: 'A Little Red Flower',
    category: 'romance',
    year: 2020,
    rating: 8.5,
    duration: '128分钟',
    director: '韩延',
    cast: ['易烊千玺', '刘浩存', '朱媛媛', '高亚麟'],
    description: '两个抗癌家庭，两组生活轨迹。影片讲述了一个温情的现实故事，思考和直面了每一个普通人都会面临的终极问题——想象死亡随时可能到来，我们唯一要做的就是爱和珍惜。韦一航和马小远在病痛中相遇相知，彼此温暖，共同面对生活的考验。',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%2C%20young%20couple%20in%20warm%20sunlight%2C%20emotional%20drama%20film%2C%20soft%20warm%20tones%2C%20minimalist%20poster%20design%2C%20gentle%20and%20touching%20aesthetic&width=600&height=900&seq=movie-littlered-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20drama%20movie%20scene%2C%20young%20couple%20walking%20in%20sunset%2C%20warm%20golden%20light%2C%20emotional%20cinematography%2C%20soft%20focus%2C%20gentle%20atmosphere%2C%20Chinese%20urban%20background&width=1600&height=700&seq=movie-littlered-cover&orientation=landscape',
    tags: ['爱情', '剧情', '温情', '抗癌'],
    resolution: '蓝光1080P',
    region: '中国大陆',
  },
  {
    id: 'your-name',
    title: '你的名字。',
    originalTitle: '君の名は。',
    category: 'animation',
    year: 2016,
    rating: 9.2,
    duration: '106分钟',
    director: '新海诚',
    cast: ['神木隆之介', '上白石萌音', '长泽雅美', '市原悦子'],
    description: '在远离大都会的小山村，住着巫女世家出身的高中女孩宫水三叶。校园和家庭的原因让她充满烦恼，而近一年发生的奇怪事件，又让三叶摸不清头脑。不知从何时起，三叶在梦中就会变成一个住在东京的高中男孩立花泷。两人就这样在梦中邂逅了彼此，展开了一段跨越时空的奇妙爱情故事。',
    posterImage: 'https://readdy.ai/api/search-image?query=Your%20Name%20anime%20movie%20poster%2C%20boy%20and%20girl%20under%20starry%20sky%2C%20comet%20falling%2C%20beautiful%20anime%20art%20style%2C%20blue%20and%20pink%20twilight%20sky%2C%20romantic%20anime%20aesthetic&width=600&height=900&seq=movie-yourname-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Your%20Name%20anime%20movie%20scene%2C%20beautiful%20twilight%20sky%20with%20comet%2C%20Japanese%20countryside%20and%20Tokyo%20cityscape%2C%20stunning%20anime%20art%2C%20blue%20and%20orange%20gradient%20sky%2C%20dreamy%20atmosphere&width=1600&height=700&seq=movie-yourname-cover&orientation=landscape',
    tags: ['动画', '爱情', '奇幻', '青春'],
    resolution: '蓝光4K',
    region: '日本',
  },
  {
    id: 'spirited-away',
    title: '千与千寻',
    originalTitle: '千と千尋の神隠し',
    category: 'animation',
    year: 2001,
    rating: 9.4,
    duration: '125分钟',
    director: '宫崎骏',
    cast: ['柊瑠美', '入野自由', '夏木真理', '菅原文太'],
    description: '千寻和爸爸妈妈一同驱车前往新家，在郊外的小路上不慎进入了神秘的隧道——他们去到了另外一个诡异世界。在那里，千寻的爸爸妈妈因为贪吃变成了猪，千寻为了救爸爸妈妈，在汤婆婆的汤屋中工作，经历了许多不可思议的冒险，也逐渐成长为一个勇敢坚强的女孩。',
    posterImage: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20anime%20movie%20poster%2C%20Chihiro%20in%20bathhouse%2C%20Studio%20Ghibli%20art%20style%2C%20No%20Face%20character%2C%20Japanese%20animation%20classic%2C%20warm%20and%20magical%20aesthetic%2C%20golden%20and%20red%20color%20tones&width=600&height=900&seq=movie-spirited-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20movie%20scene%2C%20Chihiro%20walking%20on%20train%20track%20over%20water%2C%20Studio%20Ghibli%2C%20magical%20atmosphere%2C%20beautiful%20animation%2C%20soft%20blue%20water%20and%20sky%2C%20dreamy%20fantasy%20world&width=1600&height=700&seq=movie-spirited-cover&orientation=landscape',
    tags: ['动画', '奇幻', '冒险', '成长'],
    resolution: '蓝光1080P',
    region: '日本',
  },
  {
    id: 'the-conjuring',
    title: '招魂',
    originalTitle: 'The Conjuring',
    category: 'horror',
    year: 2013,
    rating: 8.3,
    duration: '112分钟',
    director: '温子仁',
    cast: ['维拉·法米加', '帕特里克·威尔森', '莉莉·泰勒', '朗·里维斯顿'],
    description: '20世纪70年代，罗杰与卡罗琳夫妇带着五个女儿搬到了罗德岛上一栋旧宅居住。房屋虽然古旧沧桑，却让一家人体会到回归田园的快乐与喜悦。谁知好景不长，接二连三的怪异事件相继出现，令女孩们惊声尖叫。夫妇俩求助于驱魔师沃伦夫妇，而他们发现这栋房子的黑暗秘密远超想象。',
    posterImage: 'https://readdy.ai/api/search-image?query=The%20Conjuring%20horror%20movie%20poster%2C%20haunted%20house%20in%20fog%2C%20dark%20and%20eerie%20atmosphere%2C%20horror%20film%20aesthetic%2C%20minimalist%20design%2C%20black%20and%20white%20with%20sepia%20tones%2C%20creepy%20mood&width=600&height=900&seq=movie-conjuring-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=The%20Conjuring%20horror%20movie%20scene%2C%20dark%20haunted%20house%20interior%2C%20creepy%20doll%20Annabelle%2C%20eerie%20atmospheric%20lighting%2C%20horror%20cinematography%2C%20dark%20shadows%2C%20vintage%201970s%20setting&width=1600&height=700&seq=movie-conjuring-cover&orientation=landscape',
    tags: ['恐怖', '惊悚', '驱魔', '真实事件'],
    resolution: '蓝光1080P',
    region: '美国',
  },
  {
    id: 'parasite',
    title: '寄生虫',
    originalTitle: '기생충',
    category: 'suspense',
    year: 2019,
    rating: 9.2,
    duration: '132分钟',
    director: '奉俊昊',
    cast: ['宋康昊', '李善均', '赵汝贞', '崔宇植'],
    description: '基宇出生在一个贫穷的四口之家，他和妹妹基婷以及父母在狭窄的地下室里过着相依为命的日子。一天，基宇的同学上门拜访，告诉他自己在一个有钱人家里给他们的女儿做家教，太太是一个头脑简单出手又阔绰的女人。基宇伪造了学历来到朴社长家，之后他的妹妹和父母也如同寄生虫一般进入了朴社长家里工作。',
    posterImage: 'https://readdy.ai/api/search-image?query=Parasite%20Korean%20movie%20poster%2C%20family%20portrait%20with%20black%20bars%20over%20eyes%2C%20dark%20social%20thriller%20aesthetic%2C%20minimalist%20film%20poster%20design%2C%20bold%20contrast%2C%20mysterious%20mood&width=600&height=900&seq=movie-parasite-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Parasite%20Korean%20movie%20scene%2C%20modern%20luxury%20house%20with%20large%20glass%20windows%2C%20rainy%20night%2C%20dark%20cinematic%20lighting%2C%20social%20thriller%20atmosphere%2C%20contrast%20between%20wealth%20and%20poverty&width=1600&height=700&seq=movie-parasite-cover&orientation=landscape',
    tags: ['悬疑', '剧情', '社会', '黑色幽默'],
    resolution: '蓝光4K',
    region: '韩国',
  },
  {
    id: 'dunkirk',
    title: '敦刻尔克',
    originalTitle: 'Dunkirk',
    category: 'war',
    year: 2017,
    rating: 8.7,
    duration: '107分钟',
    director: '克里斯托弗·诺兰',
    cast: ['菲恩·怀特海德', '汤姆·格林-卡尼', '杰克·劳登', '哈里·斯泰尔斯'],
    description: '二战初期，40万英法盟军被敌军围困于敦刻尔克的海滩之上。面对敌军步步逼近的绝境，形势万分危急。英国政府和海军发动大批船员，动员人民起来营救军队。影片从陆、海、空三个角度讲述，在德国军队的包围下，每个人不得不为自己的命运背水一战，才有可能活着回家。',
    posterImage: 'https://readdy.ai/api/search-image?query=Dunkirk%20war%20movie%20poster%2C%20soldiers%20on%20beach%20looking%20at%20sea%2C%20World%20War%20II%2C%20cinematic%20war%20film%20style%2C%20muted%20blue%20and%20grey%20tones%2C%20minimalist%20design%2C%20dramatic%20atmosphere&width=600&height=900&seq=movie-dunkirk-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Dunkirk%20war%20movie%20scene%2C%20soldiers%20on%20beach%20with%20burning%20ships%2C%20World%20War%20II%20evacuation%2C%20cinematic%20war%20cinematography%2C%20muted%20cold%20tones%2C%20dramatic%20sky%2C%20epic%20scale&width=1600&height=700&seq=movie-dunkirk-cover&orientation=landscape',
    tags: ['战争', '历史', '剧情', '二战'],
    resolution: '蓝光4K',
    region: '英国',
  },
  {
    id: 'crazy-alien',
    title: '疯狂的外星人',
    originalTitle: 'Crazy Alien',
    category: 'comedy',
    year: 2019,
    rating: 7.8,
    duration: '116分钟',
    director: '宁浩',
    cast: ['黄渤', '沈腾', '马修·莫里森', '汤姆·派福瑞'],
    description: '耿浩与一心想发大财的好兄弟大飞，经营着各自惨淡的"事业"。一天，外星人的意外降临打破了二人平静又拮据的生活。神秘的西方力量也派出"哼哈二将"在全球寻找外星人的踪影。啼笑皆非的跨物种对决，别开生面的"星战"在中国某海边城市激情上演。',
    posterImage: 'https://readdy.ai/api/search-image?query=Crazy%20Alien%20Chinese%20comedy%20movie%20poster%2C%20Huang%20Bo%20and%20Shen%20Teng%2C%20funny%20alien%20character%2C%20colorful%20comedic%20style%2C%20Chinese%20New%20Year%20film%2C%20bright%20and%20vibrant%20design%2C%20playful%20mood&width=600&height=900&seq=movie-crazyalien-poster&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Crazy%20Alien%20Chinese%20comedy%20movie%20scene%2C%20amusement%20park%20with%20alien%20spaceship%2C%20Huang%20Bo%20and%20Shen%20Teng%2C%20colorful%20and%20funny%20cinematography%2C%20bright%20daytime%2C%20comedic%20chaos%2C%20Chinese%20urban%20setting&width=1600&height=700&seq=movie-crazyalien-cover&orientation=landscape',
    tags: ['喜剧', '科幻', '搞笑', '国产'],
    resolution: '蓝光1080P',
    region: '中国大陆',
  },
];

export const faqs = [
  {
    question: '琪琪影院的电影都是高清蓝光画质吗？',
    answer: '是的，琪琪影院所有电影均提供高清蓝光画质，部分热门电影支持4K超清画质。我们致力于为用户提供极致的观影体验，确保画面清晰流畅，让您在家也能享受影院级别的视听盛宴。',
  },
  {
    question: '琪琪影院看电影需要付费吗？',
    answer: '琪琪影院所有电影资源均为免费在线观看，无需任何付费会员。我们通过广告支持运营，用户无需注册即可观看海量电影资源，真正做到免费电影大全随心看。',
  },
  {
    question: '琪琪影院的电影资源更新频率如何？',
    answer: '琪琪影院片库每日持续更新，最新电影、热门电影第一时间上架。我们的编辑团队时刻关注全球电影动态，确保用户在琪琪影院总能找到最新最热的电影资源。',
  },
  {
    question: '看电影会卡顿缓冲吗？',
    answer: '琪琪影院采用先进的CDN加速技术和智能缓冲算法，确保电影播放流畅不卡顿。我们优化了视频传输链路，让用户在不同网络环境下都能获得流畅的观影体验。',
  },
  {
    question: '琪琪影院支持哪些设备观看？',
    answer: '琪琪影院完美适配电脑、平板、手机等多种设备，无论您使用什么终端，都能获得最佳的观影体验。我们的响应式设计确保在不同屏幕尺寸下都有良好的显示效果。',
  },
  {
    question: '如何在琪琪影院找到想看的电影？',
    answer: '您可以通过琪琪影院的分类导航快速找到喜爱的电影类型，也可以使用搜索功能直接查找电影名称。我们提供了科幻电影、动作电影、喜剧电影、爱情电影等多个分类，方便您按喜好浏览。',
  },
];

export const brandInfo = {
  name: '琪琪影院',
  founded: '2018年',
  description: '琪琪影院是国内领先的免费在线电影平台，自2018年创立以来，始终秉承"让每个人都能享受高品质观影体验"的理念，致力于打造国内最全、最新、最高清的电影大全网站。我们拥有超过50000部电影资源，涵盖科幻电影、动作电影、喜剧电影、爱情电影、恐怖电影、动画电影、悬疑电影、战争电影等全品类电影类型，每日持续更新最新电影和热门电影资源。琪琪影院采用先进的视频编码技术和CDN分发网络，确保每一部电影都能以高清蓝光画质流畅播放，让用户享受不卡顿、不缓冲的极致观影体验。',
  reputation: [
    { label: '累计用户', value: '800万+', icon: 'ri-user-heart-line' },
    { label: '电影资源', value: '50000+', icon: 'ri-film-line' },
    { label: '日均访问', value: '120万+', icon: 'ri-bar-chart-line' },
    { label: '用户好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
  ],
  contact: {
    email: 'contact@qiqicinema.com',
    wechat: '琪琪影院官方',
    weibo: '@琪琪影院',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    phone: '400-888-6666',
  },
};